import React from 'react';
import UserProfile from '../shared/UserProfile';

const WriterProfile = () => {
  return <UserProfile />;
};

export default WriterProfile;